module.exports = __webpack_public_path__ + "assets/img/study_1.2cc71be2.png";